import { LayoutContainerDto } from 'gleblu-socket-api';

import Layout from '../interfaces/layout/Layout';
import LayoutContainer from '../interfaces/layout/LayoutContainer';
import MergedTable from '../interfaces/layout/MergedTable';
import Table from '../interfaces/layout/Table';
import TableType from '../interfaces/layout/TableType';

export function fromDto(layoutContainerDto: LayoutContainerDto): LayoutContainer {
  const { layout: layoutDto, mergedTables: mergedTableDtos, tables: tableDtos, tableTypes: tableTypeDtos } = layoutContainerDto;

  const mergedTables: MergedTable[] = mergedTableDtos.map((mergedTableDto) => {
    const { uuid, layoutUuid, tableUuids, label, capacity } = mergedTableDto;
    const mergedTable = { uuid, layoutUuid, tableUuids, label, capacity };
    return mergedTable;
  });
  const tables: Table[] = tableDtos.map((tableDto) => {
    const { uuid, layoutUuid, tableTypeUuid, mergedTableUuids, label } = tableDto;
    const table = { uuid, layoutUuid, tableTypeUuid, mergedTableUuids, label };
    return table;
  });
  const tableTypes: TableType[] = tableTypeDtos.map((tableTypeDto) => {
    const { uuid, layoutUuid, tableUuid, capacity } = tableTypeDto;
    const tableType = { uuid, layoutUuid, tableUuid, capacity };
    return tableType;
  });

  const { uuid, placeUuid, tableUuids, mergedTableUuids, tableTypeUuids, label, type, isOpen } = layoutDto;
  const layout: Layout = {
    uuid,
    placeUuid,
    tableUuids,
    mergedTableUuids,
    tableTypeUuids,
    label,
    type,
    isOpen,
    size: { width: 0, height: 0 },
  };

  return {
    layout,
    mergedTables,
    tables,
    tableTypes,
  };
}

export function toDto(_: LayoutContainer): LayoutContainerDto {
  throw new Error('Not implemented!');
}
